import { createBrowserHistory, createMemoryHistory } from "history";

const serverEnv = typeof BROWSER_ENV === "undefined";
const baseFactory = serverEnv ? createMemoryHistory : createBrowserHistory;
export default baseFactory();